export const TestId = {
  // Auth
  LOGIN: {
    EMAIL_INPUT: "auth-email-input",
    PASSWORD_INPUT: "auth-password-input",
    SUBMIT_BUTTON: "auth-submit-button",
    ERROR_MESSAGE: "auth-error-message",
    USER_MENU: "auth-user-menu",
    LOGOUT_BUTTON: "auth-logout-button",
  },

  // Trucks
  TRUCK: {
    TABLE: "truck-table",
    ROW: "truck-row",
    DETAILS: "truck-details",
    NAME: "truck-name",
    STATUS: "truck-status",
    STATUS_FILTER: "truck-status-filter",
    STATUS_OPTION: (status: string) => `truck-status-option-${status}`,
    ADD_BUTTON: "truck-add-button",
    EDIT_BUTTON: "truck-edit-button",
    FORM: "truck-form",
  },

  // Truck History
  HISTORY: {
    TABLE: "history-table",
    ROW: "history-row",
    DETAILS: "history-details",
    EXPAND_BUTTON: "history-expand-button",
    DELETE_BUTTON: "history-delete-button",
    TAB: "history-tab",
  },

  // Common
  COMMON: {
    LOADING_SPINNER: "loading-spinner",
    CONFIRM_DIALOG: "confirm-dialog",
    CONFIRM_BUTTON: "confirm-button",
    QA_BANNER: "qa-environment-banner",
  },

  SIDEBAR: {
    ROOT: "sidebar",
    TOGGLE: "sidebar-toggle",
    MENU_ITEM_TRUCKS: "sidebar-menu-item-trucks",
    MENU_ITEM_USERS: "sidebar-menu-item-users",
    MENU_ITEM_LOCATIONS: "sidebar-menu-item-locations",
    MENU_ITEM_VENDORS: "sidebar-menu-item-vendors",
    MENU_ITEM_TUTORIAL: "sidebar-menu-item-tutorial",
    MENU_ITEM_STATIC_VALUES: "sidebar-menu-item-static-values",
    PROFILE: "sidebar-profile",
    PROFILE_NAME: "sidebar-profile-name",
    LANGUAGE_SELECT: "sidebar-language-select",
    LANGUAGE_OPTION_EN: "sidebar-language-option-en",
    LANGUAGE_OPTION_ID: "sidebar-language-option-id",
    THEME_SELECT: "sidebar-theme-select",
    THEME_OPTION_LIGHT: "sidebar-theme-option-light",
    THEME_OPTION_DARK: "sidebar-theme-option-dark",
    TRUCK_GROUPS_MENU: "sidebar-truck-groups-menu",
    STATIC_VALUES_MENU: "sidebar-static-values-menu",
    TRUCK_TYPE_WINGBOX: "sidebar-truck-type-wingbox",
    TRUCK_TYPE_LOSBAK: "sidebar-truck-type-losbak",
    TRUCK_TYPE_DUMP: "sidebar-truck-type-dump",
    TRUCK_GROUP: "sidebar-truck-group",
    MENU_ITEM_DEV_TOOLS: "sidebar-menu-item-dev-tools",
    MENU_ITEM_DATA_IMPORTER: "sidebar-menu-item-data-importer",
    MENU_ITEM_LOGISLY_SPX_ONCALL: "sidebar-menu-item-logisly-spx-oncall",
    DEV_TOOLS_MENU: "sidebar-dev-tools-menu",
  },
} as const;
